import React from 'react';
import { FileStack, FolderSearch, AlarmClock } from 'lucide-react';

const CARDS = [
  {
    icon: FileStack,
    title: '200 scanned pages, one folder',
    body:
      "A paralegal finishes scanning a stack of intake documents. They're all in one folder, named scan_001.pdf through scan_047.pdf. Each one has to be opened, matched to a client and a matter, renamed, and filed. It's slow, repetitive work.",
  },
  {
    icon: FolderSearch,
    title: 'The wrong matter',
    body:
      'A document gets filed under the wrong matter. Nobody notices for three weeks. When it surfaces during discovery prep, the attorney has to reconstruct the timeline to figure out where it came from and whether anything else was misfiled.',
  },
  {
    icon: AlarmClock,
    title: 'The backlog grows',
    body:
      'Every day adds more documents. The filing backlog grows because nobody has time for it. The longer it sits, the harder it gets, context fades, matters close, and unfiled documents become invisible.',
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-16 sm:my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The Filing Problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Three patterns we hear from the firms we talk to.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div
              key={i}
              className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6"
            >
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
